import { inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { Item, SnackbarService } from '@siat-fe/shared';
import { pipe, switchMap } from 'rxjs';
import { RolesService } from './struttura-ruoli-selector.service';

/**
 * State type.
 */
type ListaRuoliState = {
  listaRuoliItemResponse: Item[];
  hasError: boolean;
};

type RuoliItem = {
  id: number;
  nome: string;
};

/**
 * Initial state.
 */
const initialState: ListaRuoliState = {
  listaRuoliItemResponse: [],
  hasError: false,
};

export const ListaRuoliStore = signalStore(
  withState<ListaRuoliState>(initialState),
  withMethods((store, snackbarService = inject(SnackbarService)) => {
    /**
     * Set error.
     */
    const _setError = (hasError: boolean, _message?: string): void => {
      patchState(store, { hasError });
    };
    /**
     * Set success.
     */
    const _setSuccess = (message: string): void => {
      snackbarService.showSuccessSnackbar(message);
    };

    const _setListItem = (listaRuoliItemResponse: RuoliItem[]): void => {
      patchState(store, {
        listaRuoliItemResponse: listaRuoliItemResponse.map(ruolo => ({
          id: ruolo.id,
          name: ruolo.nome,
        })),
        hasError: false,
      });
    };
    return {
      _setError,
      _setSuccess,
      _setListItem,
    };
  }),
  withMethods((store, rolesService = inject(RolesService)) => {
    const fetchGetAllRoles = rxMethod<string>(
      pipe(
        switchMap(tipologica =>
          rolesService.fetchGetAllRoles(tipologica).pipe(
            tapResponse({
              next: (response: never[]) => store._setListItem(response),
              error: () => store._setError(true),
            })
          )
        )
      )
    );
    return {
      fetchGetAllRoles,
    };
  }),
  withMethods(store => ({
    /**
     * Reload update list.
     */
    _reloadListItem(typology: string, message: string): void {
      store.fetchGetAllRoles(typology);
      store._setSuccess(message);
    },
  }))
);
